// Bootstrap //
import { Collapse, Modal, Tab, Offcanvas } from 'bootstrap';

// Sticky //
import './custom/sticky';

// Hover Intent //
import './custom/hoverintent';

// Image compare
import ImageCompare from "image-compare-viewer";
const viewers = document.querySelectorAll(".image-compare");

for (const element of viewers) {
    const view = new ImageCompare(element, {
        showLabels: true
    }).mount();
}

// Smooth Scroll
const links = document.querySelectorAll('[href^="#"]');

for (const link of links) {
    link.addEventListener('click', smoothFn);
}

function smoothFn(e) {
    e.preventDefault();
    const href = this.getAttribute('href');
    const targetId = href.substring(1); // Remove the '#' from the href to match data-id
    const targetElement = document.querySelector(`[id="${targetId}"], [data-id="${targetId}"]`);

    if (targetElement) {
        const headerHeight = document.querySelector('.header').clientHeight;
        const offsetTop = targetElement.offsetTop - headerHeight;
        scroll({
            top: offsetTop,
            behavior: 'smooth'
        });
    }
}

// Plyr //
import Plyr from 'plyr';

// Video Player //
const video_player = Plyr.setup('.video-player', {
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
    ],
    youtube: {
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    },
    vimeo: {
        byline: false,
        portrait: false,
        title: false,
        speed: true,
        transparent: false
    }
});

// Swiper //
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);

// Logos slider //
const logoSlider = new Swiper('.logo-slider', {
    spaceBetween: 24,
    loop: false,
    centerInsufficientSlides: true,
    breakpoints: {
        0: {
            slidesPerView: 2,
        },
        576: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 6,
        },
        1400: {
            slidesPerView: 8,
        }
    },
    pagination: {
        el: '.logo-pagination',
        type: 'bullets',
        clickable: true,
    },
    autoplay: true,
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    }
});

// Pages slider //
const pagesSlider = new Swiper('.pages-slider', {
    spaceBetween: 24,
    loop: false,
    centerInsufficientSlides: true,
    watchSlidesProgress: true,
    breakpoints: {
        0: {
            slidesPerView: 1
        },
        576: {
            slidesPerView: 2
        },
        992: {
            slidesPerView: 3
        },
    },
    pagination: {
        el: '.pages-pagination',
        type: 'bullets',
        clickable: true,
    },
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    }
});

// Posts slider //
const postsSlider = new Swiper('.posts-slider', {
    spaceBetween: 24,
    loop: false,
    centerInsufficientSlides: true,
    watchSlidesProgress: true,
    breakpoints: {
        0: {
            slidesPerView: 1
        },
        576: {
            slidesPerView: 2
        },
        992: {
            slidesPerView: 3
        },
    },
    pagination: {
        el: '.posts-pagination',
        type: 'bullets',
        clickable: true,
    },
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    }
});

// Products slider //
const productsSlider = new Swiper('.products-slider', {
    spaceBetween: 24,
    loop: false,
    centerInsufficientSlides: true,
    watchSlidesProgress: true,
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2
        },
        992: {
            slidesPerView: 3
        },
    },
    pagination: {
        el: '.products-pagination',
        type: 'bullets',
        clickable: true,
    },
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    }
});

// Gallery slider //
const gallerySlider = new Swiper('.gallery-slider', {
    spaceBetween: 24,
    loop: false,
    centerInsufficientSlides: true,
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
        },
        768: {
            slidesPerView: 2,
            slidesPerGroup: 2
        },
        1400: {
            slidesPerView: 3,
            slidesPerGroup: 3
        },
    },
    pagination: {
        el: '.gallery-pagination',
        type: 'bullets',
        clickable: true,
    },
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    }
});

// Panel slider //
for (const swiperContainer of document.querySelectorAll('.panel-slider')) {
    const panelNavigation = swiperContainer.nextElementSibling;
    const nextButton = panelNavigation.querySelector('.panel-next');
    const prevButton = panelNavigation.querySelector('.panel-prev');
    const counter = panelNavigation.querySelector('.panel-counter');

    new Swiper(swiperContainer, {
        loop: true,
        centerInsufficientSlides: true,
        slidesPerView: 1,
        allowTouchMove: false,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        pagination: {
            el: counter,
            type: "fraction",
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
        }
    });
}

// Timeline Sliders //
const timelineSliders = document.querySelectorAll('.timeline-slider');

// Iterate '.timeline-slider'
for (const slider of timelineSliders) {
    const slides = slider.dataset.slides;

    // Initialize Swiper
    const timelineSlider = new Swiper(slider, {
        spaceBetween: 0,
        loop: false,
        watchOverflow: true,
        centerInsufficientSlides: true,
        pagination: {
            el: '.timeline-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1200: {
                slidesPerView: slides,
                slidesPerGroup: 2
            }
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
        }
    });
}


// Lightbox
import GLightbox from 'glightbox';

// Inizializza GLightbox
const multiLightbox = GLightbox({
    selector: '.lb',
    loop: true,
    videosWidth: 'auto',
});
const singleLightbox = GLightbox({
    selector: '.lb-single',
    loop: false,
    videosWidth: 'auto',
});

// Mixitup
// import mixitup from 'mixitup';
// import mixitupMultifilter from 'mixitup-multifilter';
// mixitup.use(mixitupMultifilter);

// Countup
import { CountUp } from 'countup.js';

// Seleziona tutti gli elementi con la classe 'count'
const countElements = document.querySelectorAll('.count');

for (const element of countElements) {
    // Ottieni l'intero target dall'attributo data-int
    const target = element.getAttribute('data-int');

    // Crea una nuova istanza di CountUp per ogni elemento
    const countUp = new CountUp(element, target, {
        enableScrollSpy: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
    });

    // Avvia l'animazione se non ci sono errori
    if (!countUp.error) {
        countUp.start();
    } else {
        console.error(countUp.error);
    }
}

import MatchHeight from '@tannerhodges/match-height';

// Credits //

// Decompress ASCII //
const decompressASCII = (art) => {
    const decompressed = art.replace(/(\d+)/g, (match, number) => ' '.repeat(number));
    console.log(decompressed.replace(/\\n\\r/g, '\n').replace(/\\n/g, '\n').replace(/\\r/g, ''));
}

document.addEventListener("DOMContentLoaded", () => {
    const art = "****97\n\r****22****71\n\r****22****71\n\r****97\n\r****97\n\r****4******12****6****************9*********15**********6\n\r******************8****5*****************6***************9****************3\n\r********6*****7****16*****5*****9*****5*****10***** \n\r*****11*****5****14*****6*****11*****3****13****1\n\r****13****5****13*****7*********************3****14****\n\r****13****5****11*****9****20****14****\n\r****13****5****10****11****20****14****\n\r1*****9*****6****8*****13****11****4****14****\n\r3****************7****6***************6******6*****5****14****\n\r6**********10****5*****************7*************7****14****\n\r";
    console.log('A DIGITAL PROJECT BY');
    decompressASCII(art);
});